import React, { useEffect, useState } from 'react';
import { PokedexHeader } from './PokedexHeader';
import { PokemonSearch } from './PokemonSearch';
import { PokemonGrid } from './PokemonGrid';
import { PokemonDetail } from './PokemonDetail';
import { pokemonData } from '../data/pokemonData';
export function Pokedex() {
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedType, setSelectedType] = useState('');
  const [selectedRegion, setSelectedRegion] = useState('');
  const [showShiny, setShowShiny] = useState(false);
  const [selectedPokemon, setSelectedPokemon] = useState(null);
  const [filteredPokemon, setFilteredPokemon] = useState([...pokemonData].sort((a, b) => a.id - b.id));
  const [shinyPokemonIds, setShinyPokemonIds] = useState(new Set());
  useEffect(() => {
    let filtered = [...pokemonData]; // Create a copy to avoid mutating the original
    if (searchTerm) {
      filtered = filtered.filter(pokemon => pokemon.name.toLowerCase().includes(searchTerm.toLowerCase()));
    }
    if (selectedType) {
      filtered = filtered.filter(pokemon => pokemon.types.includes(selectedType));
    }
    if (selectedRegion) {
      filtered = filtered.filter(pokemon => pokemon.region === selectedRegion);
    }
    // Always sort by Pokédex number (id) after filtering
    filtered.sort((a, b) => a.id - b.id);
    setFilteredPokemon(filtered);
  }, [searchTerm, selectedType, selectedRegion]);
  const handleRandomPokemon = () => {
    const randomIndex = Math.floor(Math.random() * pokemonData.length);
    setSelectedPokemon(pokemonData[randomIndex]);
  };
  // Toggle shiny form for an individual Pokémon
  const togglePokemonShiny = pokemonId => {
    setShinyPokemonIds(prevIds => {
      const newIds = new Set(prevIds);
      if (newIds.has(pokemonId)) {
        newIds.delete(pokemonId);
      } else {
        newIds.add(pokemonId);
      }
      return newIds;
    });
  };
  // Check if a specific Pokémon should show its shiny form
  const isPokemonShiny = pokemonId => {
    return showShiny || shinyPokemonIds.has(pokemonId);
  };
  return <section className="bg-slate-800/70 rounded-lg p-6 backdrop-blur-sm border border-slate-700 shadow-lg" data-id="element-190">
      <PokedexHeader data-id="element-191" />
      {selectedPokemon ? <div data-id="element-192">
          <button onClick={() => setSelectedPokemon(null)} className="mb-4 px-4 py-2 bg-red-600 hover:bg-red-700 text-white rounded-full transition-colors" data-id="element-193">
            Back to Pokédex
          </button>
          <PokemonDetail pokemon={selectedPokemon} isShiny={isPokemonShiny(selectedPokemon.id)} onToggleShiny={() => togglePokemonShiny(selectedPokemon.id)} onSelectEvolution={setSelectedPokemon} data-id="element-194" />
        </div> : <>
          <PokemonSearch searchTerm={searchTerm} setSearchTerm={setSearchTerm} selectedType={selectedType} setSelectedType={setSelectedType} selectedRegion={selectedRegion} setSelectedRegion={setSelectedRegion} showShiny={showShiny} setShowShiny={setShowShiny} onRandomPokemon={handleRandomPokemon} data-id="element-195" />
          <PokemonGrid pokemon={filteredPokemon} onSelectPokemon={setSelectedPokemon} isPokemonShiny={isPokemonShiny} onToggleShiny={togglePokemonShiny} data-id="element-196" />
        </>}
    </section>;
}